import { useState } from "react";
import { Volume2, Snail, LoaderCircle } from "lucide-react";
import { speak } from "@/lib/speech";

export const SpeakButton = ({ text, lang, testId, size = "sm", showSlow = true }) => {
  const [loading, setLoading] = useState(false);
  const dim = size === "lg" ? "h-14 w-14" : "h-8 w-8";
  const icon = size === "lg" ? 26 : 15;
  const play = async (e, rate) => {
    e.stopPropagation();
    setLoading(true);
    await speak(text, lang, rate);
    setLoading(false);
  };
  return (
    <span className="inline-flex items-center gap-1 shrink-0">
      <button
        type="button"
        data-testid={testId}
        onClick={(e) => play(e, 1)}
        className={`${dim} rounded-full bg-[hsl(var(--accent-blue-light))] text-[hsl(var(--accent-blue))] grid place-items-center hover:scale-105 active:scale-95 transition-transform`}
        aria-label="Listen"
      >
        {loading ? <LoaderCircle size={icon} className="animate-spin" /> : <Volume2 size={icon} />}
      </button>
      {showSlow && (
        <button
          type="button"
          data-testid={testId ? `${testId}-slow` : undefined}
          onClick={(e) => play(e, 0.7)}
          className="h-8 w-8 rounded-full text-slate-500 hover:text-[hsl(var(--accent-blue))] hover:bg-slate-100 grid place-items-center transition-colors"
          aria-label="Listen slowly"
        >
          <Snail size={15} />
        </button>
      )}
    </span>
  );
};
